import React, { useState, useEffect } from 'react'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import { useForm, Controller } from 'react-hook-form'
import moment from 'moment'
import {
  Panel,
  Table,
  Form,
  Message,
  IconButton,
  Icon,
  List,
  Row,
  Col,
  CheckboxGroup,
  Checkbox,
  Input,
  ControlLabel,
} from 'rsuite'
import { isValidators, isRequired } from '../../../utils/ValidatorUtils'
import { budgetFormat } from '../../../utils/formatterUtil'
import { isEmpty } from 'lodash-es'
import {
  totalData,
  getExpandedId,
  convertTablePlannedDisbursementData,
  getTotalSummary,
  getNewDataEditYearAndDate,
  getNewCostDataEditState,
} from '../periodExpenses/PeriodExpensesUtils'
import EditYearCell from '../../../components/cell/EditYearCell'
import EditDateCell from '../../../components/cell/EditDateCell'
import EditNumberCell from '../../../components/cell/EditNumberCell'
import classNames from 'classnames'
import notification from '../../../utils/notification'
import { dateAndYearValidation } from '../periodExpenses/Validation'
import { startLoading, doneLoading } from '../../../utils/loading'
import ErrorMessage from '../../../components/message/errorMessage/ErrorMessage'
import { updateWithdrawRequestBudgetWithPlanCode } from '../../../redux/actions/withdrawRequest'
import NumberFormat from 'react-number-format'
import './styles.less'

export default function PlannedDisbursement({
  schema,
  isWithdraw,
  isEditable,
  isCollapseAllTableRow,
  initialData,
  startProjectDate,
  endProjectDate,
  isAssociate,
  onChangeWithdrawBudget,
  isMulti = false,
  requestId: _requestId,
  onComplete = () => {},
}) {
  const { Column, ColumnGroup, HeaderCell, Cell } = Table

  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')
  const {
    register,
    handleSubmit,
    errors,
    control,
    setError,
    watch,
    setValue,
    getValues,
    clearErrors,
  } = useForm()
  const [tableData, setTableData] = useState([])
  const [errorMessage, setErrorMessage] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [formSchema, setFormSchema] = useState(schema)
  const [expandedRowKeys, setExpandedRowKeys] = useState([])
  const [masterExpanded, setMasterExpanded] = useState(false)
  const [subExpanded, setSubExpanded] = useState()
  const [subPlanVal, setSubPlanVal] = useState()
  const [periodExpensesData, setPeriodExpensesData] = useState([])
  const [isEdit, setIsEdit] = useState(false)
  const [checkVatRegistered, setCheckVatRegistered] = useState(false)
  const [checkExemptFrom, setCheckExemptFrom] = useState(false)
  const [requestId, setRequestId] = useState()

  const _headerCellStyle = {
    whiteSpace: 'normal',
    wordBreak: 'break-all',
    textAlign: 'center',
  }

  useEffect(() => {
    if (_requestId) {
      setRequestId(_requestId)
    }
  }, [_requestId])

  useEffect(() => {
    if (isEmpty(formSchema.periodExpensesData)) {
      return
    }

    if (isEmpty(formSchema.periodExpensesData[0].masterPlan)) {
      return
    }

    if (formSchema.periodExpensesData) {
      setPeriodExpensesData(formSchema.periodExpensesData)
    }

    if (formSchema.periodExpensesData[0].masterPlan) {
      setMasterExpanded(true)
    } else {
      setMasterExpanded(false)
    }

    // setPeriodExpensesData(formSchema.periodExpensesData)

    const newData = convertTablePlannedDisbursementData(
      formSchema.periodExpensesData,
      isEditable,
      initialData
    )
    setTableData([...newData])

    if (!isCollapseAllTableRow) {
      setExpandedRowKeys(getExpandedId(newData))
    }

    setCheckVatRegistered(formSchema.inputForm.vatRegistered.value != 0 ? true : false)
    setCheckExemptFrom(formSchema.inputForm.exemptFrom.value != 0 ? true : false)
    //setValue(formSchema.inputForm.vatRegistered.name, formSchema.inputForm.vatRegistered.value != 0 ? true : false)
    //setValue(formSchema.inputForm.exemptFrom.name, formSchema.inputForm.exemptFrom.value != 0 ? true : false)
  }, [schema, formSchema, isCollapseAllTableRow, isEditable])

  const showSaveError = (key, text) => {
    setError(key, {
      type: 'manual',
      message: text,
    })
    notification.open('error', {
      key: key,
      title: text,
      duration: 10000,
    })
  }

  const handleCallApiSaveYearAndDate = async (
    request,
    rowData,
    year,
    date,
    startDate,
    endDate,
    workPlanCode
  ) => {
    startLoading()
    setIsLoading(true)
    try {
      const response = await updateWithdrawRequestBudgetWithPlanCode(
        projectId,
        requestId,
        request.budgetCateWithPlanCode
      )
      console.log('response', response)

      if (response) {
        setFormSchema(response.forms.plannedDisbursement)
        setIsEdit(false)
        onComplete(response.forms.plannedDisbursement.isDisabled)
        notification.open('success', {
          title: 'บันทึกสำเร็จ',
          duration: 10000,
        })
      } else {
        notification.open('error', {
          title:
            response.errorMessage ||
            'เกิดข้อผิดพลาดในการบันทึก กรุณาลองใหม่อีกครั้งหรือติดต่อผู้ดูแลระบบ',
          duration: 10000,
        })
      }
    } catch (e) {
      console.log(e)
      notification.open('error', {
        title:
          e?.response?.data?.errorMessage ||
          'เกิดข้อผิดพลาดในการบันทึก กรุณาลองใหม่อีกครั้งหรือติดต่อผู้ดูแลระบบ',
        duration: 10000,
      })
    }
    doneLoading()
    setIsLoading(false)
  }

  const handleEditYearAndDate = (
    rowData,
    year,
    date,
    startDate,
    endDate,
    isEditValue = false,
    _onChangeBudget = () => {}
  ) => {
    const nextData = getNewDataEditYearAndDate(
      tableData,
      rowData,
      year,
      date,
      startDate,
      endDate,
      null,
      isEditValue
    )
    console.log('isEditValue', isEditValue)
    console.log('nextData', nextData[0].status)
    isEditValue && onChangeWithdrawBudget(nextData)
    setTableData(nextData)
    setIsEdit(nextData[0].status)
    if (!nextData[0].status) {
      clearErrors(formSchema.inputForm.inputVatNumber.name)
      setCheckVatRegistered(formSchema.inputForm.vatRegistered.value != 0 ? true : false)
      setCheckExemptFrom(formSchema.inputForm.exemptFrom.value != 0 ? true : false)
      setValue(formSchema.inputForm.inputVatNumber.name, formSchema.inputForm.inputVatNumber.value)
    }
    _onChangeBudget(getTotalSummary(nextData), nextData.slice(0, nextData.length - 1))
  }

  const handleSaveYearAndDate = (data, rowData) => {
    console.log('data', data)
    const year = data[`year_${rowData.id}`]
    const date = data[`date_${rowData.id}`]
    const startDate = data[`startDate_${rowData.id}`]
    const endDate = data[`endDate_${rowData.id}`]

    // const isInvalid = dateAndYearValidation(
    //   showSaveError,
    //   tableData,
    //   rowData,
    //   year,
    //   date,
    //   startDate,
    //   endDate,
    //   startProjectDate,
    //   endProjectDate
    // )
    // if (isInvalid) return

    let budgetCateWithPlanCode = []
    let totalBudget = 0
    let totalBudgetPlan = []

    const key = Object.keys(data.budgetWithPlanCode)

    key.forEach((item, index) => {
      var itemArr = item.split('_')
      let _data = {
        id: itemArr[1],
        planDetailId: rowData.id,
        budget: data.budgetWithPlanCode[item],
        workPlanCode: itemArr[0].substring(0, 6),
        fullPlanCode: itemArr[0],
        actionPlanCode: itemArr[0].substring(6),
      }

      budgetCateWithPlanCode.push(_data)
      //totalBudget += data.budgetWithPlanCode[item]

      //sum total of each plan
      let breakLoop = false
      if (totalBudgetPlan.length > 0) {
        totalBudgetPlan.forEach((item, index) => {
          if (!breakLoop) {
            // console.log('index of key', index)
            // console.log('index of totalBudgetPlan', tindex)
            // console.log('_data.workPlanCode', _data.workPlanCode)
            // console.log('_data.budget', _data.budget)
            // console.log('item', item)

            let plan = totalBudgetPlan.find((i) => i.fullPlanCode == _data.fullPlanCode)
            let planIndex = totalBudgetPlan.findIndex((i) => i.fullPlanCode == _data.fullPlanCode)
            //  console.log('plan', plan)
            //  console.log('planIndex', planIndex)
            //console.log('before totalBudgetPlan', totalBudgetPlan)

            if (plan && planIndex != -1) {
              let _plan = {
                fullPlanCode: _data.fullPlanCode,
                totalBudget: plan.totalBudget + _data.budget,
              }
              //console.log(plan.totalBudget + ' + ' + _data.budget + ' = ' + _plan.totalBudget)

              totalBudgetPlan.splice(planIndex, 1, _plan)
              breakLoop = true
              //console.log('after totalBudgetPlan', totalBudgetPlan)
            } else {
              let _plan = {
                fullPlanCode: _data.fullPlanCode,
                totalBudget: _data.budget,
              }
              totalBudgetPlan.push(_plan)
              breakLoop = true
            }
          }
        })
      } else {
        let _plan = {
          fullPlanCode: _data.fullPlanCode,
          totalBudget: _data.budget,
        }
        totalBudgetPlan.push(_plan)
      }
    })

    console.log('totalBudgetPlan', totalBudgetPlan)

    //เช็คจำนวนเงินรวมในแผนหลัก ไม่เกินที่ตั้งไว้
    if (periodExpensesData[0].masterPlan.masterBudgetPlanValue) {
      let masterPlanCode = periodExpensesData[0].masterPlan.masterBudgetPlanValue //.substring(0, 6)
      let masterPlanCodeBudget = periodExpensesData[0].masterPlan.masterBudgetValue || 0

      let plan = totalBudgetPlan.find((i) => i.fullPlanCode == masterPlanCode)

      if (plan) {
        if (plan.totalBudget > masterPlanCodeBudget) {
          notification.open('error', {
            title: `จำนวนเงินรวม ในแผน ${periodExpensesData[0].masterPlan.masterBudgetPlanValue}
             เกินจำนวนที่ตั้งไว้ (เกินมา ${budgetFormat(
               plan.totalBudget - masterPlanCodeBudget
             )} บาท)`,
            duration: 10000,
          })
          return
        }
      }
    }

    //เช็คจำนวนเงินรวมในแผนรอง ไม่เกินที่ตั้งไว้
    let isInValidTotalBudget = false
    periodExpensesData[0].subPlan.forEach((item, index) => {
      let subPlanCode = item.subBudgetPlanValue //?.substring(0, 6)
      let subPlanCodeBudget = item.subBudgetValue || 0

      let plan = totalBudgetPlan.find((i) => i.fullPlanCode == subPlanCode)

      if (plan) {
        if (plan.totalBudget > subPlanCodeBudget) {
          notification.open('error', {
            title: `จำนวนเงินรวม ในแผน ${item.subBudgetPlanValue}
             เกินจำนวนที่ตั้งไว้ (เกินมา ${budgetFormat(
               plan.totalBudget - subPlanCodeBudget
             )} บาท)`,
            duration: 10000,
          })
          isInValidTotalBudget = true
          return
        }
      }
    })

    if (isInValidTotalBudget) {
      return
    }

    const request = {
      // categoryOfCostId: rowData.id,
      // numberOfInstallment: rowData.numberOfInstallment,
      // date: moment(date).format('DD/MM/YYYY'),
      // startDate: moment(startDate).format('DD/MM/YYYY'),
      // endDate: moment(endDate).format('DD/MM/YYYY'),
      // budgetYear: year,
      // vatRegistered: data.vatRegistered,
      // vatNumber: data.vatNumber,
      // exemptFrom: data.exemptFrom,
      budgetCateWithPlanCode: budgetCateWithPlanCode,
    }

    console.log('request', request)

    handleCallApiSaveYearAndDate(request, rowData, year, date, startDate, endDate)
  }

  const handleEditState = (rowData, value, isEditValue = false, _onChangeBudget = () => {}) => {
    // if (rowData.isDetail) {
    //   const nextData = getNewDetailDataEditState(tableData, rowData, value, isEditValue)
    //   setTableData(nextData)
    //   isEditValue && onChangeWithdrawBudget(nextData)
    //   return
    // }

    const nextData = getNewCostDataEditState(tableData, rowData, value, isEditValue)
    console.log('next data ', nextData)
    setTableData(nextData)
    isEditValue && onChangeWithdrawBudget(nextData)
    !isWithdraw &&
      _onChangeBudget(getTotalSummary(nextData), nextData.slice(0, nextData.length - 1)) //no callback only Withdraw page
  }

  const findDefaultDate = (rowData, tableData, isStartDate) => {
    //ใช้สำหรับ set วันที่เริ่มต้นของงวด
    var date
    if (rowData.startDate) {
      //กรณีเคยกรอกไปแล้ว ใช้วันที่เคยกรอกไว้
      date = moment(rowData.startDate, 'DD/MM/YYYY').toDate()
    } else {
      //กรณีไม่เคยกรอกเคยกรอก ไปดึงวันที่สิ้นสุดงวด ของงวดก่อนหน้า
      let previousInstallmentDate
      tableData?.length > 0 &&
        tableData.forEach((item, index) => {
          //ลูป หาวันที่จากงวดก่อนหน้า
          if (item.id === rowData.id) {
            let _index = isStartDate ? index - 1 : index + 1
            if (isStartDate && tableData[_index]?.endDate) {
              //กรณีหาวันที่เรื่มงวด และมีงวดก่อนหน้า นำวันที่สิ้นสุด+1 มาเป็น default ให้
              previousInstallmentDate = moment(tableData[_index].endDate, 'DD/MM/YYYY').toDate() //convert date
              previousInstallmentDate.setUTCDate(previousInstallmentDate.getUTCDate() + 1) //set date +1
            } else {
              previousInstallmentDate = false
            }
          }
        })
      if (!previousInstallmentDate) {
        //กรณีไม่เจอข้อมูลงวดก่อนหรือวันที่สิ้นสุดของวดก่อน(เป็นการเพิ่มงวดที่ 1) ให้ default วันที่เริ่มโครงการ
        previousInstallmentDate = startProjectDate
      }
      console.log('previousInstallmentDate', previousInstallmentDate)
      date = moment(previousInstallmentDate, 'DD/MM/YYYY').toDate()
    }
    return date
  }

  const findStartDate = (rowData, tableData) => {
    //หาช่วงวันที่ ที่สามารถเลือกได้ (เริ่มต้น)
    var date = startProjectDate //set เป็นวันที่เริ่มโครงการ
    tableData?.length > 0 &&
      tableData.forEach((item, index) => {
        if (item.id === rowData.id && tableData[index - 1]?.endDate) {
          //กรณีมีงวดก่อนหน้า วันที่สามารถเลือกได้คือ วันสิ้นสุดงวดก่อน + 1
          //date = tableData[index-1]?.endDate
          // console.log('tableData[index-1]?.endDate', tableData[index - 1]?.endDate)
          date = moment(tableData[index - 1]?.endDate, 'DD/MM/YYYY').toDate() //convert date
          date.setUTCDate(date.getUTCDate() + 1) //set date +1
        }
      })
    return date
  }

  const findEndDate = (rowData, tableData) => {
    //หาช่วงวันที่ ที่สามารถเลือกได้ (สิ้นสุด)
    var date = endProjectDate //set เป็นวันที่สิ้นสุดโครงการ
    tableData?.length > 0 &&
      tableData.forEach((item, index) => {
        if (item.id === rowData.id && tableData[index + 1]?.startDate) {
          date = tableData[index + 1]?.startDate
        }
      })
    return date
  }

  const renderSaveButtonGroup = (rowData, _handleSave, _handleEdit) => {
    return (
      <>
        <IconButton
          appearance="ghost"
          icon={<Icon icon={isMulti ? 'check' : 'save'} className="bt-gost-icon-radius" />}
          onClick={handleSubmit((data) => _handleSave(data, rowData))}
          disabled={isLoading}
        >
          {isMulti ? 'ยืนยัน' : 'บันทึก'}
        </IconButton>
        <IconButton
          appearance="ghost"
          className="rs-btn-ghost-cancel"
          style={{ marginLeft: 5 }}
          icon={<Icon icon="close" className="bt-gost-icon-radius-cancel" />}
          onClick={() => {
            _handleEdit(rowData)
          }}
          disabled={isLoading}
        >
          ยกเลิก
        </IconButton>
      </>
    )
  }

  const handelerSubExpanded = (index, id) => {
    if (isEmpty(id) && isEmpty(index)) {
      return
    }

    const _style = document.getElementById(id).style.display
    const iconCircleUp = 'rs-icon rs-icon-chevron-circle-up rs-icon-size-lg'
    const iconCircleDown = 'rs-icon rs-icon-chevron-circle-down rs-icon-size-lg'

    if (_style == 'none') {
      document.getElementById(id).style.display = 'block'
      document.getElementById(`${index}_subPlanIconListItem`).className = iconCircleUp
    } else {
      document.getElementById(id).style.display = 'none'
      document.getElementById(`${index}_subPlanIconListItem`).className = iconCircleDown
    }
  }

  // console.clear()
  //console.log('periodExpensesData periodExpensesData ==> ', formSchema.periodExpensesData)

  return (
    <>
      {periodExpensesData?.map((item, index) => (
        <div key={index}>
          <Panel
            header={`การเบิกจ่าย ${item.list}`}
            bordered
            collapsible
            defaultExpanded
            key={index}
            style={{ marginBottom: 10 }}
          >
            {index == 0 && (
              <>
                <div style={{ marginBottom: 10 }}>
                  {isWithdraw && isEditable && (
                    <Message
                      showIcon
                      type="warning"
                      description={`กรุณาระบุจำนวนเงินที่จะขอเบิกในงวดนี้`}
                    />
                  )}
                </div>
                <div>
                  <Message
                    type="info"
                    style={{ marginBottom: 10 }}
                    description={
                      <div>
                        <Row>
                          <Col xs={24} sm={24} md={24} lg={24}>
                            {/* {checkVatRegistered ? (
                              <Icon icon="check-circle" size="2x" style={{ color: '#2da888' }} />
                            ) : (
                              <Icon icon="close-circle" size="2x" style={{ color: '#b9b9b9' }} />
                            )} */}
                            <span style={{ marginLeft: 5 }}>
                              {formSchema.inputForm.vatRegistered.label}

                              {formSchema.inputForm.inputVatNumber.value && (
                                <span style={{ marginLeft: 5 }}>
                                  ( {formSchema.inputForm.inputVatNumber.label} :{' '}
                                  {formSchema.inputForm.inputVatNumber.value} )
                                </span>
                              )}
                            </span>
                          </Col>

                          <Col xs={24} sm={24} md={24} lg={24} style={{ marginTop: 8 }}>
                            {/* {checkExemptFrom ? (
                              <Icon icon="check-circle" size="2x" style={{ color: '#2da888' }} />
                            ) : (
                              <Icon icon="close-circle" size="2x" style={{ color: '#b9b9b9' }} />
                            )} */}
                            <span style={{ marginLeft: 5 }}>
                              {formSchema.inputForm.exemptFrom.label}
                            </span>
                          </Col>

                          <Col xs={24} sm={24} md={24} lg={24}>
                            {formSchema.inputForm.bankInformation.isDisabled ? (
                              <>
                                <div style={{ marginLeft: 5 }}>
                                  <span style={{ marginRight: 20 }}>{'ข้อมูลการโอนงวดเงิน'}</span>
                                  <span style={{ marginRight: 20 }}>
                                    {'เลขที่บัญชี'} :{' '}
                                    {formSchema.inputForm.bankInformation.accountNo || '-ไม่ระบุ-'}
                                  </span>
                                  <span style={{ marginRight: 20 }}>
                                    {'ชื่อบัญชี'} :{' '}
                                    {formSchema.inputForm.bankInformation.accountName ||
                                      '-ไม่ระบุ-'}
                                  </span>
                                  <span style={{ marginRight: 20 }}>
                                    {'ธนาคาร'} :{' '}
                                    {formSchema.inputForm.bankInformation.bankName || '-ไม่ระบุ-'}
                                  </span>
                                  <span style={{ marginRight: 20 }}>
                                    {'สาขา '} :{' '}
                                    {formSchema.inputForm.bankInformation.branchName || '-ไม่ระบุ-'}
                                  </span>
                                </div>
                              </>
                            ) : (
                              <span style={{ marginRight: 5 }}>
                                {formSchema.inputForm.bankInformation.message}
                              </span>
                            )}
                          </Col>
                        </Row>
                      </div>
                    }
                  />

                  <Row>
                    <Col xs={24} sm={24} md={24} lg={24}>
                      <Form className="form-table" style={{ marginBottom: 10 }}>
                        <Table
                          expandedRowKeys={expandedRowKeys}
                          onExpandChange={(expanded, rowData) => {
                            if (expanded) {
                              setExpandedRowKeys((state) => [...state, rowData.id])
                            } else {
                              setExpandedRowKeys((state) =>
                                state.filter((item) => item !== rowData.id)
                              )
                            }
                          }}
                          rowKey="id"
                          autoHeight
                          data={tableData}
                          shouldUpdateScroll={false}
                          rowHeight={(rowData) => (rowData?.isDetail ? 210 : 64)}
                          bordered
                          cellBordered
                          style={{ border: '2px solid #2ca888' }}
                        >
                          {/* <Column width={132} align="center">
                            <HeaderCell style={_headerCellStyle}>ปีงบประมาณ</HeaderCell>
                            <Cell>
                              {(rowData) => {
                                if (!rowData._parent) {
                                  return (
                                    <span>{rowData.year}</span>
                                    //   <EditYearCell
                                    //     id={`year_${rowData.id}`}
                                    //     rowData={rowData}
                                    //     dataKey="year"
                                    //     register={register}
                                    //     control={control}
                                    //     errors={errors}
                                    //   />
                                  )
                                }
                              }}
                            </Cell>
                          </Column> */}

                          <Column width={170} align="center">
                            <HeaderCell style={_headerCellStyle}>วันที่เริ่มงวด</HeaderCell>
                            <Cell>
                              {(rowData) => {
                                if (!rowData._parent && rowData.children) {
                                  let _startProjectDate = findStartDate(rowData, tableData) //ช่วงวันที่สามารถเลือกได้ (เริ่มต้น)
                                  let _endProjectDate = findEndDate(rowData, tableData) //ช่วงวันที่สามารถเลือกได้ (สิ้นสุด)
                                  let defaultDate = findDefaultDate(rowData, tableData, true) //default วันที่มาให้ โดยอ้างอิงจากงวดก่อน
                                  return (
                                    <span>{rowData.startDate}</span>
                                    // <EditDateCell
                                    //   id={`startDate_${rowData.id}`}
                                    //   rowData={rowData}
                                    //   dataKey="startDate"
                                    //   register={register}
                                    //   control={control}
                                    //   errors={errors}
                                    //   startDate={_startProjectDate}
                                    //   endDate={_endProjectDate}
                                    //   defaultDate={defaultDate}
                                    // />
                                  )
                                }
                                return null
                              }}
                            </Cell>
                          </Column>

                          <Column width={170} align="center" colSpan={4}>
                            <HeaderCell style={_headerCellStyle}>วันที่สิ้นสุดงวด</HeaderCell>
                            <Cell>
                              {(rowData) => {
                                if (!rowData._parent && rowData.children) {
                                  let _startProjectDate = findStartDate(rowData, tableData) //ช่วงวันที่สามารถเลือกได้ (เริ่มต้น)
                                  let _endProjectDate = findEndDate(rowData, tableData) //ช่วงวันที่สามารถเลือกได้ (สิ้นสุด)
                                  let defaultDate //default วันที่มาให้
                                  if (rowData.endDate) {
                                    //กรณีเคยกรอกไปแล้ว ใช้วันที่เคยกรอกไว้
                                    defaultDate = moment(rowData.endDate, 'DD/MM/YYYY').toDate()
                                  } else {
                                    //กรณีไม่เคยกรอกจะไปเอาวันสิ้นสุดโครงการมา
                                    defaultDate = moment(_endProjectDate, 'DD/MM/YYYY').toDate()
                                  }
                                  return (
                                    <div style={{ width: 130 }}>
                                      <span>{rowData.endDate}</span>
                                      {/* <EditDateCell
                                        id={`endDate_${rowData.id}`}
                                        rowData={rowData}
                                        dataKey="endDate"
                                        register={register}
                                        control={control}
                                        errors={errors}
                                        startDate={_startProjectDate}
                                        endDate={_endProjectDate}
                                        defaultDate={defaultDate}
                                      />  */}
                                    </div>
                                  )
                                }

                                return <span className="column--lable">{rowData.label}</span>
                              }}
                            </Cell>
                          </Column>

                          <Column width={170} align="center">
                            <HeaderCell style={_headerCellStyle}>กำหนดส่งผลงาน</HeaderCell>
                            <Cell>
                              {(rowData) => {
                                if (!rowData._parent) {
                                  let _startProjectDate = findStartDate(rowData, tableData) //ช่วงวันที่สามารถเลือกได้ (เริ่มต้น)
                                  let _endProjectDate = findEndDate(rowData, tableData) //ช่วงวันที่สามารถเลือกได้ (สิ้นสุด)
                                  let defaultDate
                                  if (rowData.date) {
                                    //กรณีเคยกรอกไปแล้ว ใช้วันที่เคยกรอกไว้
                                    defaultDate = moment(rowData.date, 'DD/MM/YYYY').toDate()
                                  } else {
                                    //กรณีไม่เคยกรอกจะไปเอาวันสิ้นสุดโครงการมา
                                    defaultDate = moment(_endProjectDate, 'DD/MM/YYYY').toDate()
                                  }
                                  return (
                                    <span>{rowData.date}</span>
                                    // <EditDateCell
                                    //   id={`date_${rowData.id}`}
                                    //   rowData={rowData}
                                    //   dataKey="date"
                                    //   register={register}
                                    //   control={control}
                                    //   errors={errors}
                                    //   startDate={_startProjectDate}
                                    //   endDate={_endProjectDate}
                                    //   defaultDate={defaultDate}
                                    // />
                                  )
                                }
                                return null
                              }}
                            </Cell>
                          </Column>

                          <Column
                            width={170}
                            minWidth={120}
                            flexGrow={isAssociate ? 1 : 0}
                            align="right"
                          >
                            <HeaderCell style={_headerCellStyle}>จำนวนเงิน (บาท)</HeaderCell>
                            <Cell>
                              {(rowData) => {
                                if (
                                  (rowData.children && rowData.children[0].isDetail) ||
                                  rowData.isDetail
                                ) {
                                  return
                                } else if (!rowData._parent && rowData.children) {
                                  return (
                                    <span className={'cost-summary'}>
                                      {budgetFormat(rowData.masterCost)}
                                    </span>
                                  )
                                }

                                return (
                                  <EditNumberCell
                                    rowData={rowData}
                                    dataKey="cost"
                                    register={register}
                                    control={control}
                                    errors={errors}
                                    isBudgetFormat={true}
                                  />
                                )
                              }}
                            </Cell>
                          </Column>

                          <Column width={150} align="right">
                            <HeaderCell style={_headerCellStyle}>VAT</HeaderCell>
                            <Cell>
                              {(rowData) => {
                                if (rowData.enableVat) {
                                  return (
                                    <EditNumberCell
                                      id={`vat_${rowData.id}`}
                                      rowData={rowData}
                                      dataKey="vat"
                                      register={register}
                                      control={control}
                                      errors={errors}
                                      isRequired={false}
                                      isBudgetFormat={true}
                                    />
                                  )
                                }

                                return <span>{budgetFormat(rowData.vat || '')}</span>
                              }}
                            </Cell>
                          </Column>

                          <Column width={200} align="right">
                            <HeaderCell
                              style={{
                                whiteSpace: 'normal',
                                wordBreak: 'break-all',
                                textAlign: 'center',
                              }}
                            >
                              ภาษี ณ ที่จ่าย (บาท)
                            </HeaderCell>
                            <Cell>
                              {(rowData) => {
                                if (rowData) {
                                  return <span>{budgetFormat(rowData.withholdingTax || 0)}</span>
                                }
                              }}
                            </Cell>
                          </Column>

                          {isEditable && (
                            <Column width={235} align="center" fixed="right">
                              <HeaderCell style={_headerCellStyle}>แก้ไข</HeaderCell>
                              <Cell>
                                {(rowData) => {
                                  if (rowData.isTotal) {
                                    return null
                                  }
                                  if (!rowData._parent) {
                                    if (rowData.status === 'EDIT') {
                                      return renderSaveButtonGroup(
                                        rowData,
                                        handleSaveYearAndDate,
                                        handleEditYearAndDate
                                      )
                                    } else {
                                      const parent = rowData.isDetail
                                        ? rowData._parent._parent
                                        : rowData._parent
                                      if (rowData.isDetail && isWithdraw) {
                                        //check if withdraw page hide edit detail
                                        return null
                                      } else {
                                        return (
                                          <IconButton
                                            appearance="ghost"
                                            className="rs-btn-ghost-edit"
                                            size="sm"
                                            icon={
                                              <Icon
                                                icon="edit"
                                                className="bt-gost-icon-radius-edit"
                                              />
                                            }
                                            onClick={() => {
                                              console.log('handleEditState', rowData)
                                              handleEditYearAndDate(rowData)
                                            }}
                                            // \\disabled={!parent.date || !parent.year || parent.disabled}
                                          >
                                            แก้ไข
                                          </IconButton>
                                        )
                                      }
                                    }
                                  }
                                  return null
                                }}
                              </Cell>
                            </Column>
                          )}
                        </Table>
                      </Form>
                    </Col>
                  </Row>
                </div>
              </>
            )}

            {/* แผนหลัก */}
            <div>
              <List bordered>
                <List.Item
                  style={{ cursor: 'pointer' }}
                  onClick={() => {
                    console.log('hide list item')
                    setMasterExpanded(!masterExpanded)
                  }}
                >
                  <Row style={{ color: '#2da888' }}>
                    <Col xsHidden xs={22}>
                      <b>แผนงบประมาณ</b>
                    </Col>
                    <Col xs={2} style={{ textAlign: 'right' }}>
                      <div style={{ marginRight: 8 }}>
                        {masterExpanded ? (
                          <>
                            <Icon icon="chevron-circle-up" size="lg" />
                          </>
                        ) : (
                          <>
                            <Icon icon="chevron-circle-down" size="lg" />
                          </>
                        )}
                      </div>
                    </Col>
                  </Row>
                </List.Item>
                <List.Item>
                  <Row>
                    <Col xsHidden xs={2} style={{ color: '#4c4cf5', fontWeight: 'bold' }}>
                      <u>แผนหลัก</u>
                    </Col>
                    <Col
                      xs={18}
                      style={{
                        borderLeft: '3px solid gray',
                        borderRight: '3px solid gray',
                        minHeight: 30,
                      }}
                    >
                      {formSchema.periodExpensesData[index].masterPlan?.masterBudgetPlanText}
                    </Col>
                    <Col xs={4} style={{ textAlign: 'right' }}>
                      {budgetFormat(
                        formSchema.periodExpensesData[index].masterPlan?.masterBudgetValue
                      )}
                    </Col>
                  </Row>
                </List.Item>

                {masterExpanded && (
                  <List.Item>
                    <Row>
                      <Col xsHidden xs={24}>
                        {item.masterPlan?.children?.map((cateItem, cateIndex) => {
                          return (
                            <Row key={cateIndex}>
                              <Col
                                xs={20}
                                sm={20}
                                md={20}
                                lg={20}
                                style={{
                                  textAlign: 'right',
                                  borderStyle:
                                    cateIndex == 0 ? 'dashed' : 'none dashed dashed dashed',
                                }}
                              >
                                <div style={{ padding: 8 }}>{cateItem.label}</div>
                              </Col>
                              <Col
                                xs={4}
                                sm={4}
                                md={4}
                                lg={4}
                                style={{
                                  textAlign: 'right',
                                  borderStyle:
                                    cateIndex == 0
                                      ? 'dashed dashed dashed none'
                                      : 'none dashed dashed none',
                                }}
                              >
                                {!isEdit ? (
                                  <div style={{ padding: 8 }}>{budgetFormat(cateItem.cost)}</div>
                                ) : (
                                  <div style={{ padding: 2.5 }}>
                                    {/* <Input
                                      name={`budgetWithPlanCode[${item.masterPlan.masterBudgetPlanValue}_${cateItem.id}]`}
                                      // disabled={!optionSelected?.includes(data.value)}
                                      placeholder={formSchema.inputForm.inputVatNumber.label}
                                      defaultValue={cateItem.cost || 0}
                                      inputRef={register()}
                                    /> */}
                                    <Controller
                                      name={`budgetWithPlanCode[${item.masterPlan?.masterBudgetPlanValue}_${cateItem.id}]`}
                                      control={control}
                                      defaultValue={cateItem.cost || 0}
                                      rules={{ required: 'กรุณากรอกจำนวนเงิน' }}
                                      render={(props) => {
                                        return (
                                          <NumberFormat
                                            className={classNames(
                                              'rs-input',
                                              errors[props.name] && 'is-error'
                                            )}
                                            thousandSeparator={true}
                                            value={props.value}
                                            onValueChange={(value) => {
                                              props.onChange(value.floatValue || 0)
                                            }}
                                          />
                                        )
                                      }}
                                    />
                                  </div>
                                )}
                              </Col>
                            </Row>
                          )
                        })}
                        <Row>
                          <Col
                            xs={20}
                            sm={20}
                            md={20}
                            lg={20}
                            style={{ textAlign: 'right', borderStyle: 'none dashed dashed dashed' }}
                          >
                            <div style={{ padding: 8, fontWeight: 'bold' }}>รวมจำนวนเงิน</div>
                          </Col>
                          <Col
                            xs={4}
                            sm={4}
                            md={4}
                            lg={4}
                            style={{ textAlign: 'right', borderStyle: 'none dashed dashed none' }}
                          >
                            <div style={{ padding: 8, fontWeight: 'bold' }}>
                              {budgetFormat(item.masterPlan?.cost)}
                            </div>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </List.Item>
                )}
              </List>
            </div>

            {/* แผนรอง */}
            {item.subPlan?.map((subBudgetPlanItem, index) => {
              // console.log('subBudgetPlanItem ggg ', subBudgetPlanItem)
              return (
                <div style={{ marginTop: 10 }} key={index}>
                  <List bordered>
                    <List.Item
                      style={{ cursor: 'pointer' }}
                      onClick={() => {
                        handelerSubExpanded(index, `${index}_subPlanListItem`)
                      }}
                    >
                      <Row style={{ color: '#2da888' }}>
                        <Col xsHidden xs={22}>
                          <b>แผนงบประมาณ</b>
                        </Col>
                        <Col xs={2} style={{ textAlign: 'right' }}>
                          <div style={{ marginRight: 8 }}>
                            <Icon
                              icon="chevron-circle-up"
                              size="lg"
                              id={`${index}_subPlanIconListItem`}
                            />
                          </div>
                        </Col>
                      </Row>
                    </List.Item>
                    <List.Item>
                      <Row>
                        <Col xsHidden xs={2} style={{ color: '#6e6ebb', fontWeight: 'bold' }}>
                          <u>{`(${index + 1})แผนรอง`}</u>
                        </Col>
                        <Col
                          xs={18}
                          style={{
                            borderLeft: '3px solid gray',
                            borderRight: '3px solid gray',
                            minHeight: 30,
                          }}
                        >
                          {subBudgetPlanItem.subBudgetPlanText}
                        </Col>
                        <Col xs={4} style={{ textAlign: 'right' }}>
                          {budgetFormat(subBudgetPlanItem.subBudgetValue)}
                        </Col>
                      </Row>
                    </List.Item>

                    <List.Item id={`${index}_subPlanListItem`}>
                      <Row>
                        <Col xsHidden xs={24}>
                          {subBudgetPlanItem.children?.map((cateItem, cateIndex) => {
                            return (
                              <Row key={cateIndex}>
                                <Col
                                  xs={20}
                                  sm={20}
                                  md={20}
                                  lg={20}
                                  style={{
                                    textAlign: 'right',
                                    borderStyle:
                                      cateIndex == 0 ? 'dashed' : 'none dashed dashed dashed',
                                  }}
                                >
                                  <div style={{ padding: 8 }}>{cateItem.label}</div>
                                </Col>
                                <Col
                                  xs={4}
                                  sm={4}
                                  md={4}
                                  lg={4}
                                  style={{
                                    textAlign: 'right',
                                    borderStyle:
                                      cateIndex == 0
                                        ? 'dashed dashed dashed none'
                                        : 'none dashed dashed none',
                                  }}
                                >
                                  {!isEdit ? (
                                    <div style={{ padding: 8 }}>{budgetFormat(cateItem.cost)}</div>
                                  ) : (
                                    <div style={{ padding: 2.5 }}>
                                      {/* <Input
                                          name={`budgetWithPlanCode[${subBudgetPlanItem.subBudgetPlanValue}_${cateItem.id}]`}
                                          // disabled={!optionSelected?.includes(data.value)}
                                          placeholder={formSchema.inputForm.inputVatNumber.label}
                                          defaultValue={cateItem.cost || 0}
                                          inputRef={register()}
                                        /> */}
                                      <Controller
                                        name={`budgetWithPlanCode[${subBudgetPlanItem.subBudgetPlanValue}_${cateItem.id}]`}
                                        control={control}
                                        defaultValue={cateItem.cost || 0}
                                        rules={{ required: 'กรุณากรอกจำนวนเงิน' }}
                                        render={(props) => {
                                          return (
                                            <NumberFormat
                                              className={classNames(
                                                'rs-input',
                                                errors[props.name] && 'is-error'
                                              )}
                                              thousandSeparator={true}
                                              value={props.value}
                                              onValueChange={(value) => {
                                                props.onChange(value.floatValue || 0)
                                              }}
                                            />
                                          )
                                        }}
                                      />
                                    </div>
                                  )}
                                </Col>
                              </Row>
                            )
                          })}
                          <Row>
                            <Col
                              xs={20}
                              sm={20}
                              md={20}
                              lg={20}
                              style={{
                                textAlign: 'right',
                                borderStyle: 'none dashed dashed dashed',
                              }}
                            >
                              <div style={{ padding: 8, fontWeight: 'bold' }}>รวมจำนวนเงิน</div>
                            </Col>
                            <Col
                              xs={4}
                              sm={4}
                              md={4}
                              lg={4}
                              style={{
                                textAlign: 'right',
                                borderStyle: 'none dashed dashed none',
                              }}
                            >
                              <div style={{ padding: 8, fontWeight: 'bold' }}>
                                {budgetFormat(subBudgetPlanItem.cost)}
                              </div>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </List.Item>
                  </List>
                </div>
              )
            })}

            <div style={{ marginTop: 10, marginBottom: 30 }}>
              <List bordered>
                <List.Item style={{ backgroundColor: '#2da888' }}>
                  <Row style={{ textAlign: 'right', color: '#ffffff', fontWeight: 'bold' }}>
                    <Col xsHidden xs={20}>{`รวมจำนวนเงินแผนหลักและแผนรอง ${item.list}`}</Col>
                    <Col xsHidden xs={4}>
                      {budgetFormat(periodExpensesData[index].cost)}
                    </Col>
                  </Row>
                </List.Item>
              </List>
            </div>
          </Panel>
        </div>
      ))}
    </>
  )
}
